// extracted by mini-css-extract-plugin
export default {"emojiModalDiv":"Emoji_emojiModalDiv__CGXG+","showEmojiModalBtn":"Emoji_showEmojiModalBtn__CJ7eq","emojiModal":"Emoji_emojiModal__1y1ZL"};